export default __webpack_public_path__ + "static/media/gallery-5-2.14f02ee5.webp";